import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../components/DynamicCrudPage';
import { useGroups, useTags, SCREENS } from '../../hooks';
import AddIcon from '@mui/icons-material/Add';

const GroupsPage = () => {
  const { t } = useTranslation();

  // Custom form fields transformation
  const customFormFields = useCallback((fields, additionalData, isRootUser) => {
    const { groups, tags } = additionalData;
    const users = groups?.users || [];
    const companies = groups?.companies || [];
    const tagsList = tags?.tags || [];

    const getEligibleManagers = () => {
      return users.filter(user => 
        ['ROOT', 'DIRECTOR', 'GROUP_MANAGER'].includes(user.role)
      );
    };

    const eligibleManagers = getEligibleManagers();
    
    return fields
      .map(field => {
        if (field.name === 'companyId') {
          return {
            ...field,
            options: companies.map(c => ({ value: c.id, label: c.name })),
            showIf: () => isRootUser,
          };
        }
        if (field.name === 'managerId') {
          return {
            ...field,
            options: [
              { value: '', label: 'Atanmamış' },
              ...eligibleManagers.map(u => ({ 
                value: u.id, 
                label: `${u.firstName || u.first_name} ${u.lastName || u.last_name} (${u.role})` 
              })),
            ],
          };
        }
        if (field.name === 'tagIds') {
          const groupTags = tagsList.filter(tag => tag.tags_page === 'GROUPS');
          return {
            ...field,
            options: groupTags.map(tag => ({
              value: tag.id,
              label: tag.name
            })),
          };
        }
        return field;
      })
      .filter(field => (field.name === 'companyId' ? isRootUser : true));
  }, []);

  // Custom filter configs
  const customFilterConfigs = useCallback((filters, data, isRootUser) => {
    return filters.filter(f => f.showIfRoot ? isRootUser : true);
  }, []);

  // Transform edit data for form
  const transformEditData = useCallback((groupData) => {
    if (!groupData) return {};
    
    return {
      ...groupData,
      managerId: groupData.group_manager_id,
      companyId: groupData.company_id,
      tagIds: groupData.group_tags?.map(gt => gt.tag_id) || [],
    };
  }, []);

  // Transform form data for submission
  const transformFormData = useCallback((formData) => {
    return {
      ...formData,
      group_manager_id: formData.managerId,
      company_id: formData.companyId,
    };
  }, []);

  return (
    <DynamicCrudPage
      entityType="groups"
      screen={SCREENS.GROUPS}
      hook={useGroups}
      additionalHooks={{ groups: useGroups, tags: useTags }}
      customFormFields={customFormFields}
      customFilterConfigs={customFilterConfigs}
      addButtonTextKey="table.actions.addGroup"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="group"
      customTransformEditData={transformEditData}
      customTransformFormData={transformFormData}
      showAddButton={true}
    />
  );
};

export default GroupsPage; 